import { LoadingSpinner } from '@ctw/shared/components/loading-spinner';
import { type PropsWithChildren, useEffect, useState } from 'react';

interface DeferRenderingProps extends PropsWithChildren {
  milliseconds: number;
  message?: string;
}

export const DeferRendering = ({ milliseconds, message, children }: DeferRenderingProps) => {
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    const timeoutId = setTimeout(() => setShouldRender(true), milliseconds);
    return () => clearTimeout(timeoutId);
  }, [milliseconds]);

  if (!shouldRender) {
    return <LoadingSpinner centered={true} message={message} />;
  }

  return children;
};
